import client from "./client";

export const myConsents = async () => (await client.get("/consents/me")).data;
export const acceptConsents = async (kinds, version, language, platform) =>
  (await client.post("/consents/accept", { kinds, version, language, platform })).data;
export const withdrawBiometric = async (reason) =>
  (await client.post("/consents/biometric/withdraw", { reason })).data;
